import { UserPlus, UserRound } from "lucide-react";

export const childToStudent = (c) => ({ first: c?.first || "", last: c?.last || "", klass: c?.class || "" });

export default function ChildPicker({ items, selectedId, onPick }) {
  if (!items?.length) return null;
  const chip = (active) => `flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${active ? "border-amber-deep bg-amber-deep text-white" : "border-amber-800/25 bg-white text-bark hover:border-amber-deep"}`;
  return (
    <div data-testid="child-picker" className="flex flex-wrap gap-2">
      {items.map((c) => (
        <button key={c.id} type="button" data-testid={`child-chip-${c.id}`} onClick={() => onPick(c)} className={chip(selectedId === c.id)}>
          <UserRound size={13} /> {c.first} {c.last} · {c.class}
        </button>
      ))}
      <button type="button" data-testid="child-chip-new" onClick={() => onPick(null)} className={chip(selectedId === null)}>
        <UserPlus size={13} /> Autre enfant
      </button>
    </div>
  );
}
